import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { SettingsRoutingModule } from './settings.routing';
import { ValidationService } from '../form-validation/validation.service';
import { SettingsComponent } from './settings.component';
import { SettingsService } from './settings.service';

// import {Ng2TelInputModule} from 'ng2-tel-input';

import { ThemeService } from './theme.service';

@NgModule({ declarations: [
        SettingsComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        SettingsRoutingModule], providers: [ValidationService, SettingsService, ThemeService, provideHttpClient(withInterceptorsFromDi())] })
export class SettingsModule { }
